import React, { Component } from "react";
import styled from "styled-components";
import neo_insurance from "../assets/svgs/neoInsuranceLogoWhite_risk.svg";
import { colors, theme } from "theme";
import { Page, Input, LargeButton, Ptag } from "../components/core";
import { Navigate } from "react-router";
import { Tab, TabsWrapper } from "./sideNavContent";
import routes from "./routes";
export default class sideNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
  }

  navigateToMainDashboard = () => {
    this.setState({ redirect: true });
  };

  render() {
    const getButtonColor = (route) => {
      if (
        window.location.pathname == route ||
        window.location.pathname == "/" + route
      ) {
        return theme.whiteColor;
      }
      return "#cacaca";
    };
    const showUserData = () => {
      return (
        window.location.pathname == "/" ||
        window.location.pathname == "/user-profile" ||
        window.location.pathname == "/change-password"
      );
    };
    const logout = () => {
      window.history.pushState({}, "", "/");
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    };
    return (
      <Page>
        {this.state.redirect && <Navigate to="/" />}
        <HomeWrapperLeft>
          <NeoLogoWrapper onClick={() => this.navigateToMainDashboard()}>
            <img  style={{height:'36px'}} src={neo_insurance} />
          </NeoLogoWrapper>
          <LogoBorder />
          {showUserData() && (
            <TabsWrapper>
              <Tab href={`/`}>
                <Ptag
                  textAlign="left"
                  fontSize="18px"
                  letterHeight="26px"
                  color={getButtonColor("/")}
                  fontWeight="500"
                >
                  Home
                </Ptag>
              </Tab>
              <Tab href={`/${routes.USER_PROFILE}`}>
                <Ptag
                  textAlign="left"
                  fontSize="18px"
                  letterHeight="26px"
                  color={getButtonColor(routes.USER_PROFILE)}
                  fontWeight="500"
                >
                  My Profile
                </Ptag>
              </Tab>
              <Tab onClick={() => logout()}>
                <Ptag
                  textAlign="left"
                  fontSize="18px"
                  letterHeight="26px"
                  fontWeight="500"
                  color="#cacaca"
                >
                  Logout
                </Ptag>
              </Tab>
            </TabsWrapper>
          )}
          {this.props.children}
        </HomeWrapperLeft>
      </Page>
    );
  }
}

const HomeWrapperLeft = styled.div`
  background: linear-gradient(to bottom, #221b3c, #440e69);
  position: fixed;
  height: 100%;
  width: 252px;
  box-sizing: border-box;
  padding-top: 4.4rem;
  transition: width 0.2s ease-in;
  align-items: center;
  overflow-y: scroll;
  padding-bottom: 2rem;
`;
const NeoLogoWrapper = styled.div`
  width: 100%;
  cursor: pointer;
  text-align: center;
  & > img {
    padding: 0 24px;
    max-width: 240px;
  }
`;

const LogoBorder = styled.div`
  margin: 0 auto;
  width: 70%;
  height: 1px;
  margin-top: 1rem;
  background-color: #e5f7ff;
  opacity: 0.7;
`;
